export const KEYCODE = {
  RETURN: 13,
  ESCAPE: 27,
  SPACE: 32,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  TAB: 9
};

export const focusableElements = [
  '[contenteditable]',
  '[tabindex]:not([tabindex^="-"])',
  'a[href]',
  'area[href]',
  'button:not([disabled]):not([aria-hidden])',
  'embed',
  'iframe',
  'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
  'object',
  'select:not([disabled]):not([aria-hidden])',
  'textarea:not([disabled]):not([aria-hidden])'
];

export function setBlockSizes() {
  const $refs = document.querySelectorAll('[data-block-size-ref]');

  requestAnimationFrame(() => {
    $refs.forEach((ref) => {
      ref.parentNode.style.removeProperty('--block-size');
      requestAnimationFrame(() => {
        const blockSize = ref.clientHeight;
        ref.parentNode.style.setProperty('--block-size', `${blockSize}px`);
      });
    });
  });

  document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
}

export function listenBlockSizes() {
  const config = { attributes: false, childList: true, subtree: true };
  const $refs = document.querySelectorAll('[data-block-size-ref]');

  $refs.forEach((ref) => {
    const callback = (mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          const blockSize = ref.clientHeight;
          ref.parentNode.style.setProperty('--block-size', `${blockSize}px`);
        }
      });
    };
    const observer = new MutationObserver(callback);
    observer.observe(ref, config);
  });
}

export function setLocks() {
  const $refs = document.querySelectorAll('.locked');

  $refs.forEach((lock) => {
    // const lastWord = lock.textContent.trim().split(' ').pop();
    const span = document.createElement('span');
    // span.classList.toggle('single-word', lastWord === lock.textContent.trim());
    // span.textContent = ` ${lastWord}`;
    // lock.textContent = lock.textContent
    //   .trim()
    //   .split(' ')
    //   .slice(0, -1)
    //   .join(' ');
    lock.appendChild(span);
  });
}

export const BREAKPOINTS = {
  TABLET: 768,
  TABLET_LANDSCAPE: 1024,
  DESKTOP: 1440,
  WIDE: 1600,
  EXTRA_WIDE: 2000
};

export function classNames(...args) {
  return args.filter((arg) => arg).join(' ');
}

export const isSafari = () =>
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const isMobile = () =>
  window.matchMedia(`(max-width: ${BREAKPOINTS.TABLET_LANDSCAPE - 1}px)`)
    .matches;

export const isSmallMobile = () =>
  window.matchMedia(`(max-width: ${BREAKPOINTS.TABLET - 1}px)`).matches;

export function arrayToOptions(arr) {
  return arr.map((item) => ({ Label: item, Value: item }));
}

export const removeDiacritics = (string) =>
  string
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export function scrollToElement(selector) {
  window.requestAnimationFrame(() => {
    document
      .querySelector(selector)
      ?.scrollIntoView({ block: 'start', behavior: 'smooth' });
  });
}

export const setTrackDataLayer = ({ eventName, custom }) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...custom
  });
};

export function secondsToHHMMSS(timeInSeconds) {
  const secNum = parseInt(timeInSeconds, 10);
  let hours = Math.floor(secNum / 3600);
  let minutes = Math.floor((secNum - hours * 3600) / 60);
  let seconds = secNum - hours * 3600 - minutes * 60;

  if (hours < 10) {
    hours = `0${hours}`;
  }
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  if (seconds < 10) {
    seconds = `0${seconds}`;
  }
  return `${hours}:${minutes}:${seconds}`;
}
